import {
    Grid
} from "@mui/material";

import MDBox from "../../../components/MDBox";

function RelationshipsTab(){
    return (
        <MDBox bgColor="gray-100" sx={{width: "100%", display: "flex"}}>
            <Grid container justifyContent="center">
                <Grid item my={1}>

                </Grid>
            </Grid>
        </MDBox>
    );
}

export default RelationshipsTab;